export const getServerOrderType = (orderType) => {
    const orderTypes = {
        'sale': 'order',
        'refund': 'refund',
        'prepaid': 'prepaid',
        'credit': 'credit',
    }

    return orderTypes[orderType] || 'order';
};

export const transformDistricts = (apiData) => {
    // Make sure apiData is always an array
    if (!Array.isArray(apiData)) return [];

    return apiData.map(district => ({
        id: district.id,
        name: district.name,
        market: Array.isArray(district.market) ? district.market : []
    }));
};
